import React from "react";

import { normalizeClientCorrespondenceImportKey } from "../hooks/useDataManagerOrdersUtils.js";

export const BILL_TO_AUCUN = "aucun";
const NEW_COMPANY_OPTION = "__nouvelle_entreprise__";

// Noms des entreprises facturées (fiches Clients « Entreprise facturée » = OUI) offerts aux listes « Facturer à ».
export const BillToCompaniesContext = React.createContext([]);

const sameName = (left, right) => normalizeClientCorrespondenceImportKey(left) === normalizeClientCorrespondenceImportKey(right);

/**
 * « Facturer à » : une entreprise facturée de la liste, ou « Nouvelle entreprise… » pour taper un nom
 * qui crée la fiche à l'enregistrement. Une valeur enregistrée hors de la liste reste visible, « non valide ».
 */
export default function BillToSelect({ value, onChange, companies, allowAucun = false, allowEmpty = false, allowNew = true,
  className = "", disabled = false, ariaLabel = "Facturer à", onKeyDown, onCommit, dataGridFocusKey, title }) {
  const contextCompanies = React.useContext(BillToCompaniesContext);
  const names = companies ?? contextCompanies;
  const current = String(value ?? "").trim();
  const [typing, setTyping] = React.useState(false);
  const known = names.find((name) => sameName(name, current)) || (allowAucun && sameName(current, BILL_TO_AUCUN) ? BILL_TO_AUCUN : null);
  if (typing) {
    return (
      <input
        aria-label={`${ariaLabel} : nouvelle entreprise`}
        autoFocus
        className={className}
        data-grid-focus-key={dataGridFocusKey}
        disabled={disabled}
        onBlur={() => onCommit?.(current)}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Escape") {
            setTyping(false);
          } else if (event.key === "Enter") {
            onCommit?.(current);
          }
          onKeyDown?.(event);
        }}
        placeholder="Nom de la nouvelle entreprise"
        title={title}
        type="text"
        // Le texte tapé reste tel quel (espaces compris) ; il est nettoyé à l'enregistrement.
        value={String(value ?? "")}
      />
    );
  }
  return (
    <select
      aria-label={ariaLabel}
      className={className}
      data-grid-focus-key={dataGridFocusKey}
      disabled={disabled}
      onChange={(event) => {
        if (event.target.value === NEW_COMPANY_OPTION) {
          setTyping(true);
          onChange("");
          return;
        }
        onChange(event.target.value);
        onCommit?.(event.target.value);
      }}
      onKeyDown={onKeyDown}
      title={title}
      value={known ?? current}
    >
      {!current || allowEmpty ? <option value="">{allowEmpty ? "—" : "Choisir…"}</option> : null}
      {current && !known ? <option value={current}>{current} (non valide)</option> : null}
      {names.map((name) => <option key={name} value={name}>{name}</option>)}
      {allowAucun ? <option value={BILL_TO_AUCUN}>aucun</option> : null}
      {allowNew ? <option value={NEW_COMPANY_OPTION}>Nouvelle entreprise…</option> : null}
    </select>
  );
}
